import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { version } from '../../constants/endpoints';

const categoriaReceitaEndPoint = `${version}/categoria/receita`;
const categoriaDespesaEndPoint = `${version}/categoria/despesa`;

export const useCategoria = () => {
  const { backendGet, backendPost, backendPut } = Sebrae.useBackend();

  const isConvidado = React.useCallback((empresa) => {
    return empresa?.isConvidado ? `-convidado/${empresa?.id}` : '';
  }, []);

  const buscarCategoriaReceita = React.useCallback(
    (empresa) =>
      backendGet(`${categoriaReceitaEndPoint}${isConvidado(empresa)}`),
    [backendGet, isConvidado],
  );
  const buscarCategoriaDespesa = React.useCallback(
    (empresa) =>
      backendGet(`${categoriaDespesaEndPoint}${isConvidado(empresa)}`),
    [backendGet, isConvidado],
  );

  const buscarCategoriaReceitaPorId = React.useCallback(
    (id) => backendGet(`${categoriaReceitaEndPoint}/${id}`),
    [backendGet],
  );

  const buscarCategoriaDespesaPorId = React.useCallback(
    (id) => backendGet(`${categoriaDespesaEndPoint}/${id}`),
    [backendGet],
  );
  const buscarSubcategoriaReceitaPorId = React.useCallback(
    (id) => backendGet(`${categoriaReceitaEndPoint}/subcategoria/${id}`),
    [backendGet],
  );

  const buscarSubcategoriaDespesaPorId = React.useCallback(
    (id) => backendGet(`${categoriaDespesaEndPoint}/subcategoria/${id}`),
    [backendGet],
  );
  const buscarCategoriaPorFiltro = React.useCallback(
    (idCategoria) => backendGet(`${version}/categoria/${idCategoria}`),
    [backendGet],
  );
  const salvarCategoriaReceita = React.useCallback(
    (data, empresa) =>
      backendPost(
        `${categoriaReceitaEndPoint}/${empresa?.id}${
          empresa?.isConvidado ? '/convidado' : ''
        }`,
        data,
      ),
    [backendPost],
  );
  const salvarCategoriaDespesa = React.useCallback(
    (data, empresa) =>
      backendPost(
        `${categoriaDespesaEndPoint}/${empresa?.id}${
          empresa?.isConvidado ? '/convidado' : ''
        }`,
        data,
      ),
    [backendPost],
  );
  const atualizaCategoriaReceita = React.useCallback(
    (data) => backendPut(`${categoriaReceitaEndPoint}`, data),
    [backendPut],
  );
  const atualizaCategoriaDespesa = React.useCallback(
    (data) => backendPut(categoriaDespesaEndPoint, data),
    [backendPut],
  );
  const salvarSubcategoriaReceita = React.useCallback(
    (data) => backendPost(`${categoriaReceitaEndPoint}/subcategoria`, data),
    [backendPost],
  );
  const salvarSubcategoriaDespesa = React.useCallback(
    (data) => backendPost(`${categoriaDespesaEndPoint}/subcategoria`, data),
    [backendPost],
  );
  const atualizaSubcategoriaReceita = React.useCallback(
    (data) => backendPut(`${categoriaReceitaEndPoint}/subcategoria`, data),
    [backendPut],
  );
  const atualizaSubcategoriaDespesa = React.useCallback(
    (data) => backendPut(`${categoriaDespesaEndPoint}/subcategoria`, data),
    [backendPut],
  );
  const excluirCategoriaReceita = React.useCallback(
    (data) => backendPut(`${categoriaReceitaEndPoint}/excluir`, data),
    [backendPut],
  );
  const excluirCategoriaDespesa = React.useCallback(
    (data) => backendPut(`${categoriaDespesaEndPoint}/excluir`, data),
    [backendPut],
  );
  const excluirSubcategoriaReceita = React.useCallback(
    (data) =>
      backendPut(`${categoriaReceitaEndPoint}/subcategoria/excluir`, data),
    [backendPut],
  );
  const excluirSubcategoriaDespesa = React.useCallback(
    (data) =>
      backendPut(`${categoriaDespesaEndPoint}/subcategoria/excluir`, data),
    [backendPut],
  );
  const buscarLancamentoCategoriaReceitaPorId = React.useCallback(
    (id) => backendGet(`${categoriaReceitaEndPoint}/${id}/lancamento`),
    [backendGet],
  );
  const buscarLancamentoCategoriaDespesaPorId = React.useCallback(
    (id) => backendGet(`${categoriaDespesaEndPoint}/${id}/lancamento`),
    [backendGet],
  );
  const buscarLancamentoSubcategoriaReceitaPorId = React.useCallback(
    (id) =>
      backendGet(`${categoriaReceitaEndPoint}/subcategoria/${id}/lancamento`),
    [backendGet],
  );
  const buscarLancamentoSubcategoriaDespesaPorId = React.useCallback(
    (id) =>
      backendGet(`${categoriaDespesaEndPoint}/subcategoria/${id}/lancamento`),
    [backendGet],
  );

  return {
    buscarCategoriaReceita,
    buscarCategoriaDespesa,
    buscarCategoriaReceitaPorId,
    buscarCategoriaDespesaPorId,
    buscarSubcategoriaReceitaPorId,
    buscarSubcategoriaDespesaPorId,
    buscarCategoriaPorFiltro,
    salvarCategoriaReceita,
    salvarCategoriaDespesa,
    atualizaCategoriaReceita,
    atualizaCategoriaDespesa,
    salvarSubcategoriaReceita,
    salvarSubcategoriaDespesa,
    atualizaSubcategoriaReceita,
    atualizaSubcategoriaDespesa,
    excluirCategoriaReceita,
    excluirCategoriaDespesa,
    excluirSubcategoriaReceita,
    excluirSubcategoriaDespesa,
    buscarLancamentoCategoriaReceitaPorId,
    buscarLancamentoCategoriaDespesaPorId,
    buscarLancamentoSubcategoriaReceitaPorId,
    buscarLancamentoSubcategoriaDespesaPorId,
  };
};
